import { fromJS } from 'immutable';
import { mergeEntity, normalizeEntities } from 'helpers/utilHelpers';

import {
  LOAD_CREDENTIALS_SUCCESS,
  LOAD_CREDENTIAL_GROUPS_SUCCESS,
  CHANGE_FAVORITE,
  LOAD_CREDENTIAL_BY_ID_SUCCESS,
  UPDATE_CREDENTIAL_SUCCESS,
  UPDATE_CREDENTIAL_GROUP_SUCCESS,
  DELETE_CREDENTIAL_SUCCESS,
  DELETE_CREDENTIAL_GROUP_SUCCESS,
  LOAD_PROJECT_CREDENTIALS_SUCCESS,
  UPDATE_PROJECT_CREDENTIAL_SUCCESS,
  CLEAR_CREDENTIAL_GROUPS,
} from 'constants/ActionTypes';

const initialState = fromJS({
  credentials: {},
  credentialGroups: {},
});

/**
 * Function for prepare credential item
 * @param credential
 * @param groups
 * @return {*}
 */
const prepareCredential = (credential, groups) => {
  const excludingCredential = ['group'];

  if (credential.group && groups) {
    groups.push(credential.group);
  }

  excludingCredential.forEach((field) => delete credential[field]);

  return credential;
};

const credentialReducer = (state = initialState, action) => {
  let groups = [];

  switch (action.type) {
    case LOAD_PROJECT_CREDENTIALS_SUCCESS:
    case LOAD_CREDENTIALS_SUCCESS: {
      const credentials = action.credentials.items.map((credential) => prepareCredential({ ...credential }, groups));
      return state.set('credentials', normalizeEntities(credentials, 'accessId', state.get('credentials')));
    }
    case LOAD_CREDENTIAL_GROUPS_SUCCESS:
      return state.set('credentialGroups', normalizeEntities(action.credentialGroups.items, 'groupId'));
    case CLEAR_CREDENTIAL_GROUPS: {
      return state.set('credentialGroups', initialState.get('credentialGroups'));
    }
    case LOAD_CREDENTIAL_BY_ID_SUCCESS: {
      const credential = prepareCredential({ ...action.access }, groups);
      return state.setIn(
        ['credentials', credential.accessId],
        mergeEntity(credential, state.getIn(['credentials', credential.accessId])),
      );
    }
    case CHANGE_FAVORITE:
      if (action.change) {
        return state.setIn(['credentials', action.accessId, 'favorite'], true);
      } else {
        return state.setIn(['credentials', action.accessId, 'favorite'], false);
      }
    case UPDATE_PROJECT_CREDENTIAL_SUCCESS:
    case UPDATE_CREDENTIAL_SUCCESS: {
      const credential = prepareCredential({ ...action.credential }, groups);
      return state.setIn(
        ['credentials', credential.accessId],
        mergeEntity(credential, state.getIn(['credentials', credential.accessId])),
      );
    }
    case UPDATE_CREDENTIAL_GROUP_SUCCESS: {
      const group = { ...action.group };

      return state.setIn(
        ['credentialGroups', group.groupId],
        mergeEntity(group, state.getIn(['credentialGroups', group.groupId])),
      );
    }
    case DELETE_CREDENTIAL_SUCCESS:
      return state.deleteIn(['credentials', action.accessId]);
    case DELETE_CREDENTIAL_GROUP_SUCCESS:
      return state.deleteIn(['credentialGroups', action.groupId]);
    default:
      return state;
  }
};

export default credentialReducer;
